/**
 * Whether a path sits under a navigation entry. Detail pages inherit their list
 * page's section, so it is a prefix match, bounded at a segment separator —
 * unbounded, `/admin` would also claim `/administration`.
 */
export function isUnder(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(`${to}/`);
}

/**
 * Which entry is highlighted. The longest match wins, so `/dashboard` does not
 * steal the highlight from `/dashboard/metrics-history` — a nested section is
 * always a better answer than the one it is nested in.
 */
export function activePath(pathname: string, paths: string[]): string | undefined {
  return paths
    .filter((to) => isUnder(pathname, to))
    .sort((a, b) => b.length - a.length)[0];
}
